<!--
 * @Description: 
 * @Author: xz
 * @Date: 2023-11-22 10:07:21
 * @LastEditTime: 2023-11-24 16:28:08
 * @LastEditors: xz
-->
<template>
    <div style="width: 100%;height: 100%;" v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" v-body="true"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div ref="mynetwork" id="mynetwork" style="width: 100%; height: 100%">
            <RelationGraph ref="seeksRelationGraph_mynetwork" :options="graphOptions" :on-node-click="onNodeClick">
                <div slot="node" slot-scope="{ node }" @contextmenu.prevent.stop="showNodeMenus(node, $event)">
                    <!--    @mouseover="showNodeTips(node, $event)"
                @mouseout="hideNodeTips(node, $event)" -->
                    <div class="node">
                        <i style="font-size: 30px" class="el-icon-coin" />
                    </div>
                    <div class="node_text" :title="node.text">
                        {{ node.text }}
                    </div>
                </div>
                <div slot="bottomPanel" class="bottomPanel">
                    这里是底部插槽 slot="bottomPanel",可以自定义这里的内容
                </div>
            </RelationGraph>
        </div>
        <div class="drawer" v-if="dialogTableVisiblejd">
            <el-drawer custom-class="drawer_right" title="节点信息" :visible.sync="dialogTableVisiblejd" direction="rtl"
                :modal="false">
                <div class="detail">
                    <div class="detail_item">
                        <div class="detail_item_title">节点</div>
                        <div class="detail_item_value">{{ chooseData.name ? chooseData.name : chooseData.label }}</div>
                    </div>
                    <div v-if="chooseData.Authors" class="detail_item">
                        <div class="detail_item_title">作者</div>
                        <div class="detail_item_value">{{ chooseData.Authors }}</div>
                    </div>
                    <div v-if="chooseData.Keywords" class="detail_item">
                        <div class="detail_item_title">关键字</div>
                        <div class="detail_item_value">{{ chooseData.Keywords }}</div>
                    </div>
                    <div v-if="chooseData.Abstract" class="detail_item">
                        <div class="detail_item_title">摘要</div>
                        <div class="detail_item_value">{{ chooseData.Abstract }}</div>
                    </div>
                    <div v-if="chooseData.area" class="detail_item">
                        <div class="detail_item_title">活动范围</div>
                        <div class="detail_item_value">{{ chooseData.area }}</div>
                    </div>
                    <div class="detail_item" v-if="chooseData.description">
                        <div class="detail_item_title">描述 </div>
                        <div class="detail_item_value">{{ chooseData.description }}</div>
                    </div>
                    <div class="detail_item" v-if="chooseData.nameother">
                        <div class="detail_item_title">别名</div>
                        <div class="detail_item_value"> {{ chooseData.nameother }}</div>
                    </div>
                    <div class="detail_item"
                        v-if="(chooseData.path || chooseData.photolist) && !chooseData.path.includes('.pdf')">
                        <div class="detail_item_title">图片</div>
                        <div class="detail_item_value">
                            <img style="width: 60%; margin-left: 20%" :src="chooseData.path.replace(
                                '/home/tscon/we/mcc/',
                                'http://edam.tscon.cn:7777/mcc/'
                            )
                                " />
                        </div>
                    </div>
                    <div class="detail_item">
                        <el-button type="primary" v-if="chooseData.isbook" @click="preViewBook(chooseData)">查看</el-button>

                        <el-button type="primary" @click="goDe2(chooseData)">图谱扩展</el-button>
                        <el-button type="primary" v-if="chooseData.path && chooseData.path.includes('.pdf')"
                            @click="checkPdfFile(chooseData.path)">预览</el-button>
                    </div>
                </div>
            </el-drawer>
        </div>
        <el-dialog title="预览" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
            <iframe v-if="dialogVisible" :src="fileURL" frameborder="0" style="width: 100%; height: 65vh"></iframe>
        </el-dialog>
        <div v-show="iframeShow" class="iframeClass">
            <div style="border: 1px solid">
                <el-button type="info" icon="el-icon-close" size="small" @click="iframeShow = false">取消预览</el-button>
            </div>
            <!-- <iframe :src="fileUrl" frameborder="0" width="100%" height="100%"></iframe> -->
            <iframe :src="'/mcc/earthgo/static/pdfjs/web/viewer.html?file=' +
                iframeUrl +
                '&keyword=' +
                askinfo
                " frameborder="0" width="100%" height="100%"></iframe>
        </div>

    </div>
</template>
<script>
import RelationGraph from "relation-graph";
import userapi from "@/api/user";
import { TUP, fileUrl, KKFILEURL } from "../../../../utils/baseUrl";
import { Base64 } from "js-base64";
export default {
    components: {
        RelationGraph,
    },
    props: {
        graphData: {
            type: Object
        }
    },
    watch: {
        graphData: {
            deep: true,
            handler(newVal, oldVal) {
                const graphInstance = this.$refs.seeksRelationGraph_mynetwork.getInstance()
                if (newVal.nodes) {
                    graphInstance.addNodes(newVal.nodes);
                }
                if (newVal.edges) {
                    graphInstance.addLines(newVal.edges);
                }
                graphInstance.doLayout();
            }
        }
    },
    data() {
        return {
            loading: false,
            askinfo: "",
            iframeShow: false,
            iframeUrl: '',
            dialogVisible: false,
            fileURL: '',
            dialogTableVisiblejd: false,
            chooseData: {},
            searchinfo: "",
            graphOptions: {

                hideNodeContentByZoom: true,
                allowShowMiniToolBar: true,
                allowSwitchLineShape: true,
                allowSwitchJunctionPoint: true,
                defaultJunctionPoint: "border",
                // allowSwitchLineShape: true,
                // allowSwitchJunctionPoint: true,
                // defaultJunctionPoint: "border",
                // layouts: [
                //   {
                //     label: "自动布局",
                //     layoutName: "force",
                //     layoutClassName: "seeks-layout-force",
                //   },
                // ],
                layouts: [
                    {
                        // layoutName: "force",
                        // layoutClassName: "seeks-layout-force",
                        "layoutName": "center",
                        // "distance_coefficient": 
                    },
                ],

                // 这里可以参考"Graph 图谱"中的参数进行设置
            },
            nodesList: [],
            listList: []
        };
    },
    mounted() {
        this.searchinfo = this.$route.query.searchinfo == undefined ? "" : this.$route.query.searchinfo;
        if (this.$route.query.searchinfo != undefined) {
            // console.log("我飞！")
            window.location.hash = "#map";
        }
        this.chushihuaCanvas();
    },
    methods: {
        // 关闭标签
        handleClose(done) {
            done();
        },
        chushihuaCanvas() {
            this.loading = true
            let nodesList = []
            let listList = []
            userapi.getRequest("/api/getTupuTree", { text: this.searchinfo }).then((res) => {
                nodesList.push({
                    id: "0",
                    text: "知识图谱",
                    data: {
                        label: "知识图谱"
                    }
                });
                res.data.forEach((item) => {
                    let dataList = {
                        isNeedLoadDataFromRemoteServer: false,
                        childrenLoaded: false,
                    }
                    if (typeof item == 'object') {
                        for (let i in item) {
                            dataList[i] = item[i]
                        }
                    } else {
                        dataList.label = item
                    }
                    nodesList.push({
                        id: item.c_id.toString(),
                        text: item.c_name,
                        expandHolderPosition: "right",
                        expanded: true,
                        data: dataList
                    });
                    listList.push({
                        from: item.c_pid.toString(),
                        to: item.c_id.toString(),
                    });
                });
                const __graph_json_data = {
                    rootId: "a",
                    nodes: nodesList,
                    lines: listList,
                };
                // 以上数据中的node和link可以参考"Node节点"和"Link关系"中的参数进行配置
                this.$refs.seeksRelationGraph_mynetwork.setJsonData(__graph_json_data);
                this.loading = false
            });
            this.loading = false
        },
        onNodeClick(nodeObject, $event) {
            // console.log("onNodeClick:", nodeObject);
            if (nodeObject.data.c_desc) {
                this.loading = true
                userapi
                    .getRequest("/api/getType", {
                        type: nodeObject.data.c_desc,
                    })
                    .then((res) => {
                        let nodes = []
                        let lineList = []
                        if (Array.isArray(res.data.data)) {
                            let data = new Set(res.data.data);
                            let arrarData = Array.from(data).slice(0, 20);
                            arrarData.forEach((item) => {
                                let id = nodeObject.id.toString() + item;
                                // let id = item;
                                let dataList = {
                                    isNeedLoadDataFromRemoteServer: false,
                                    childrenLoaded: false,
                                }
                                if (typeof item == 'object') {
                                    for (let i in item) {
                                        dataList[i] = item[i]
                                    }
                                    dataList.id = id
                                } else {
                                    dataList.label = item
                                    dataList.id = id
                                }
                                nodes.push({
                                    id: id.toString(),
                                    text: item,
                                    expandHolderPosition: "right",
                                    expanded: true,
                                    data: dataList,
                                });
                                lineList.push({
                                    from: nodeObject.id.toString(),
                                    to: id.toString(),
                                });
                            });
                        }
                        // this.listList.push(lineList)
                        // this.nodesList.push(nodes)
                        // this.$refs.seeksRelationGraph_mynetwork.setJsonData({
                        //     rootId: "a",
                        //     nodes: this.nodesList,
                        //     lines: this.listList,
                        // })
                        const graphInstance = this.$refs.seeksRelationGraph_mynetwork.getInstance();
                        graphInstance.addNodes(nodes);
                        graphInstance.addLines(lineList);
                        graphInstance.doLayout(); // 使用graphOptions中设置的布局器布局
                        this.$refs.seeksRelationGraph_mynetwork.refresh()
                        graphInstance.moveToCenter();
                        this.loading = false
                        // await callback();
                    });
            } else {
                this.dialogTableVisiblejd = true;
                this.chooseData = nodeObject.data
            }
        },
        //图谱扩展  存在接口执行不通
        goDe2(data) {
            this.loading = true
            let nodeData = data
            let text = data.name ? data.name : data.label
            userapi.getRequest("/api/getTupuTreeByData", {
                text: text,
            }).then(res => {
                let nodes = []
                let lineList = []
                res.data.data.edges.forEach(item => {
                    lineList.push({
                        from: item.from.toString(),
                        to: item.to.toString(),
                        text: item.label
                    })
                })
                res.data.data.nodes.forEach(item => {
                    let dataList = {
                        isNeedLoadDataFromRemoteServer: false,
                        childrenLoaded: false,
                    }
                    if (typeof item == 'object') {
                        for (let i in item) {
                            dataList[i] = item[i]
                        }
                    } else {
                        dataList.label = item
                    }
                    nodes.push({
                        id: item.id,
                        text: item.name,
                        expandHolderPosition: "right",
                        expanded: true,
                        data: dataList,
                    })
                    lineList.push({
                        from: nodeData.id.toString(),
                        to: item.id.toString(),
                    })
                })
                const graphInstance = this.$refs.seeksRelationGraph_mynetwork.getInstance();
                graphInstance.addNodes(nodes);
                graphInstance.addLines(lineList);
                graphInstance.doLayout();
                graphInstance.dataUpdated();
                this.$refs.seeksRelationGraph_mynetwork.refresh()
                graphInstance.moveToCenter();
                // this.listList.push(lineList)
                // this.nodesList.push(nodes)
                // const graphInstance = this.$refs.seeksRelationGraph_mynetwork.getInstance();
                // this.$refs.seeksRelationGraph_mynetwork.setJsonData({
                //     rootId: "a",
                //     nodes: this.nodesList,
                //     lines: this.listList,
                // })
                this.loading = false
                this.dialogTableVisiblejd = false

            })
        },
        // 查看pdf文件
        checkPdfFile(data) {
            this.dialogVisible = true
            this.fileURL = KKFILEURL + "/onlinePreview?url=" + encodeURIComponent(Base64.encode(data.replace(
                '/home/tscon/we/mcc/',
                'http://edam.tscon.cn:7777/mcc/'
            )));
        },
        preViewBook(item) {
            this.loading = true
            userapi
                .getRequest("/search/dealBook", {
                    keyword: item.bookkey,
                    fileurl: item.bookurl,
                })
                .then((res) => {
                    this.loading = false
                    this.iframeUrl = res.data.replace(
                        "/home/tscon/we/mcc/",
                        "http://edam.tscon.cn:7777/mcc/"
                    );
                    this.iframeShow = true;
                    this.dialogTableVisiblejd = false
                });
        },

    },
};
</script>

<style scoped>
.detail_item {
    width: 100%;
    text-align: left;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.detail_item_title {
    width: 80px !important;
    font-size: 16px;
}

.detail_item_value {
    width: 80% !important;

}

.node {
    height: 80px;
    line-height: 80px;
    border-radius: 50%;
    cursor: pointer;
}

.node_text {
    color: forestgreen;
    font-size: 14px;
    position: absolute;
    width: 160px;
    padding: 5px;
    /* height: 25px; */
    line-height: 25px;
    margin-top: 5px;
    margin-left: -48px;
    text-align: center;
    background-color: rgba(66, 187, 66, 0.2);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

}

.bottomPanel {
    border-top: #efefef solid 1px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 18px;
    background-color: #ffffff;
}

.drawer /deep/ .drawer_right {
    width: 95%;
    height: calc(100vh - 60px);
    position: absolute;
    top: 60px;

}
</style>



// WEBPACK FOOTER //
// src/views/Tupu/comp/tupu_right.vue